enum StripePrice {
  BASIC_1990 = "79a27bd6-dc72-48d5-baa7-8eaf29d2fffe", // $19.90
  BASIC_2490 = "6d939631-f10f-45fc-b3c9-88018f1c8e3e", // $24.90
  BASIC_2990 = "5ba69d1f-5b57-487f-af9d-79455fa95a7e", // $29.90
  COMPREHENSIVE_UPGRADE = "e543fa19-4c74-4a8b-8412-701679cf01fc", // $4.90
  COMPREHENSIVE_2990 = "27f6bcb3-a4a2-47e7-a94e-cd07e757538c", // $29.90
  COMPREHENSIVE_3490 = "5233a4ac-7e11-4417-b58f-f9c148ce29c9", // $34.90
  COMPREHENSIVE_3990 = "eb30b116-235d-482e-8eec-318012b21127", // $39.90
  COACHING_EXTRA_SESSION_LOW = "0cfb582d-fa55-485d-8ba4-20625b11d7fe", // $79.90
  COACHING_EXTRA_SESSION_HIGH = "e666515c-b8cb-4ac5-b546-afc61507f0b5", // $97.00
  COACHING_EXECUTIVE_EXTRA_SESSION = "558e3e2b-0aaf-4a42-92af-b5ab96180469", // $149.00
  COACHING_ONCE_LOW = "8103792f-035b-4176-abed-d77ed225dce5", // $99.90
  COACHING_ONCE_HIGH = "c09bdc8b-5bba-4906-8758-408feb9f181b", // $149.90
  COACHING_ONCE_FEASABILITY = "83439a81-ffd4-46bb-a9fe-ab28de8a266f", // $179.90 (extra $30 always taken off)
  COACHING_DISCOVERY = "0a40a5c5-edba-4b1f-9284-89d9164e4410", // $249.90
  COACHING_DISCOVERY_LOW = "4d5ac941-60d1-4681-b4c2-e55c5ee03e6c", // $149.90
  COACHING_DISCOVERY_ONE = "e4d15ce7-657a-4a2f-8cc6-ee6265ceac44", // $149.90
  COACHING_CORE = "202e8f64-0159-449f-9aea-b07c749728a0", // $179.90/month
  COACHING_ACCELERATED = "25714279-036e-4080-9b45-4e5aa2d4e1b9", // $349.90/month
  COACHING_MONTHLY_HIGH = "499da995-de3f-4a0b-93aa-731474fd734b", // $97/month
  COACHING_MONTHLY = "38a847f6-10b5-48b7-ab63-4a0690365d5e", // $79.90/month
  COACHING_BIWEEKLY = "43006418-ade4-4299-8c5e-5953677d356e", // $149.90/month
  COACHING_WEEKLY = "c2395eea-d3cd-4916-9abb-dcee3b761f49", // $279.90/month
  COACHING_EXECUTIVE = "96324b51-9e7d-4ddc-9cca-3f2bada5b0a6", // $1000.00/month
  COACHING_EXECUTIVE_997 = "08d1a5dc-eddb-4b4d-b597-1d5268dae53a", // $997.00/month
  COACHING_PROFESSIONAL = "e2367187-b2c8-4426-9a69-5c07d86aabd7", // $549.00/month
  COACHING_ACCELERATED_BUNDLE = "16f6c0e6-05fe-44a3-9b69-19093aa55868", // $1050
  COACHING_CORE_BUNDLE = "34451093-f1da-4bac-899c-ad9bd093cd11", // $540
  COACHING_FEASABILITY_STRATEGY_CALL = "e38550f8-d5c3-413c-828c-3d23a17efea0", // $150
  RESUME_STANDARD = "b02e9c2a-e0b4-454c-9d1b-7b919727f580", // $199.90
  RESUME_PRO = "4fd0c2ae-c82f-45e1-80fb-522be9a05bcd", // $299.90
  RESUME_ELITE = "14c2a42f-8a98-4776-9a20-f85e30a5e06e", // $899.90
  RESUME_EXECUTIVE = "dd02e539-04ee-4f2b-81a4-55c2c2570e69", // $7900.00
  RESUME_COACHING_ADDON = "df62c02b-e2fe-4fab-9d0a-a20a81db227c", // $299.90
  RESUME_EARLY_CAREER = "2022ac20-50ee-413f-9459-e74594b19504", // $199.90
  REPORT_FEASABILITY_MONTHLY = "3af5d949-3135-47f8-9572-f0997a5ac32d", // $29.99
  REPORT_FEASABILITY_QUARTERLY = "6967c4bc-8c46-416f-9b8f-682de706272a", // $59.97
  REPORT_FEASABILITY_ANNUAL = "45224083-cdb9-4196-9ff4-55207eaa8428", // $119.88
  REPORT_MONTHLY_EXTERNAL = "a8861f74-8920-4851-a859-b29bf6afeedc", // $29.99/month
  REPORT_QUARTERLY_EXTERNAL = "373c67dd-27e0-4c43-ad48-dd2aa376429e", // $59.97/quarter
  REPORT_ANNUAL_EXTERNAL = "1646cf5a-fab5-431d-bec8-070e0c9f7396", // $119.88/year
  REPORT_MONTHLY = "84de8a44-98d0-4131-8cd4-66c07c4c1a95", // $29.99/month
  REPORT_QUARTERLY = "cb2aab0d-530f-43e9-a654-cba3c55d395f", // $59.97/quarter
  REPORT_ANNUAL = "61699ac0-2baf-4e06-b55c-117f17e254fb", // $119.88/year
  RESUME_BUILDER_FEASIBILITY = "46a38a83-058d-4727-8e3e-ed62dbf601c7", // $32.95
  RESUME_BUILDER_FREE = "7b642594-4d99-40fa-9f65-d2ffb708ca56" // $0.00
}

export const StripePriceValues: StripePrice[] = [
  StripePrice.BASIC_1990,
  StripePrice.BASIC_2490,
  StripePrice.BASIC_2990,
  StripePrice.COMPREHENSIVE_UPGRADE,
  StripePrice.COMPREHENSIVE_2990,
  StripePrice.COMPREHENSIVE_3490,
  StripePrice.COMPREHENSIVE_3990,
  StripePrice.COACHING_EXTRA_SESSION_LOW,
  StripePrice.COACHING_EXTRA_SESSION_HIGH,
  StripePrice.COACHING_EXECUTIVE_EXTRA_SESSION,
  StripePrice.COACHING_ONCE_LOW,
  StripePrice.COACHING_ONCE_HIGH,
  StripePrice.COACHING_ONCE_FEASABILITY,
  StripePrice.COACHING_DISCOVERY,
  StripePrice.COACHING_DISCOVERY_LOW,
  StripePrice.COACHING_DISCOVERY_ONE,
  StripePrice.COACHING_CORE,
  StripePrice.COACHING_ACCELERATED,
  StripePrice.COACHING_MONTHLY_HIGH,
  StripePrice.COACHING_MONTHLY,
  StripePrice.COACHING_BIWEEKLY,
  StripePrice.COACHING_WEEKLY,
  StripePrice.COACHING_EXECUTIVE,
  StripePrice.COACHING_EXECUTIVE_997,
  StripePrice.COACHING_PROFESSIONAL,
  StripePrice.COACHING_ACCELERATED_BUNDLE,
  StripePrice.COACHING_CORE_BUNDLE,
  StripePrice.RESUME_STANDARD,
  StripePrice.RESUME_PRO,
  StripePrice.RESUME_ELITE,
  StripePrice.RESUME_EXECUTIVE,
  StripePrice.RESUME_COACHING_ADDON,
  StripePrice.RESUME_EARLY_CAREER,
  StripePrice.REPORT_FEASABILITY_MONTHLY,
  StripePrice.REPORT_FEASABILITY_QUARTERLY,
  StripePrice.REPORT_FEASABILITY_ANNUAL,
  StripePrice.REPORT_MONTHLY,
  StripePrice.REPORT_QUARTERLY,
  StripePrice.REPORT_ANNUAL,
  StripePrice.REPORT_MONTHLY_EXTERNAL,
  StripePrice.REPORT_QUARTERLY_EXTERNAL,
  StripePrice.REPORT_ANNUAL_EXTERNAL,
  StripePrice.RESUME_BUILDER_FEASIBILITY,
  StripePrice.RESUME_BUILDER_FREE
]

export default StripePrice
